module.exports = __webpack_public_path__ + "static/media/thirdareaproduct4.f95af770.jpg";